import React from "react"
//import I18n from "i18n-js/index.js.erb"
import DateHelper from "../../DateHelper/DateHelper"
import clsx from "clsx"

class HousekeepingLogTimeline extends React.Component {
  
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.activeTab == "status_timeline",
      'tab-pane': true
    });

    var timeline = []
      if (this.props.finished_at) {
        timeline.push(
          {finished: this.props.finished_at},
          {started: this.props.started_at},
          {acknowledged: this.props.acknowledged_at ? this.props.acknowledged_at : this.props.started_at},
        )
      } else if (this.props.started_at) {
        timeline.push(
          {started: this.props.started_at},
          {acknowledged: this.props.acknowledged_at ? this.props.acknowledged_at : this.props.started_at},
        )
      } else if (this.props.acknowledged_at) {
        timeline.push(
          {acknowledged: this.props.acknowledged_at},
        )
      }
    timeline.push({submitted: this.props.created_at})

    var timelineEvents = timeline.map((event) => {
      return (
        <div key={Object.keys(event)[0]} className="payment-log-timeline-event">
          <div className="icon"><span className="ss-check"></span></div>
          <div className="event-date">
            <div className="event">{I18n.t(Object.keys(event)[0])}</div>
            <div className="date">{DateHelper.parseToDateTimeString(Object.values(event)[0], this.props.date_format, this.props.time_format)}</div>
          </div>
        </div>
      )
    })

    return(
      <div className={tabClasses} id="status_timeline">
        <div className="panel panel-default payment-log payment-log-timeline">
          <div className="panel-body">
            {timelineEvents}
          </div>
        </div>
      </div>
    )
  }

}

export default HousekeepingLogTimeline